import { useAuth } from '../contexts/AuthContext';

// Whether a switchable feature (backend/config/features.js) is on for the
// signed-in user's club. Anything the server hasn't said is off counts as on,
// so older cached sign-ins and signed-out pages lose nothing.
export const hasFeature = (user, key) => user?.features?.[key] !== false;

// The signed-in user, or null outside an AuthProvider (useAuth throws there
// after reading the context, so the hook order is the same either way)
function useUserOrNull() {
  try {
    return useAuth()?.user ?? null;
  } catch {
    return null;
  }
}

export function useFeature(key) {
  return hasFeature(useUserOrNull(), key);
}

export function useFeatures() {
  const user = useUserOrNull();
  return (key) => hasFeature(user, key);
}
